import { rootUrl } from "./apiRequests";

export const login = (usernameParam, userPwdParam) => {
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
  
	const mainData = JSON.stringify({
	  usuario: usernameParam,
	  password: userPwdParam,
	});
  
	var reqConfig = {
	  method: "POST",
	  headers: headers,
	  body: mainData,
	  redirect: "follow",
	};
  
	return fetch(rootUrl + "login.php", reqConfig)
	  .then((res) => {
		return res.json();
	  })
	  .then((result) => {
		return result;
	  })
	  .catch((err) => console.log("error >>", err));
};
export const register = (usernameParam, userPwdParam) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const mainData = JSON.stringify({
    usuario: usernameParam,
    password: userPwdParam,
  });

  var reqConfig = {
    method: "POST",
    headers: headers,
    body: mainData,
    redirect: "follow",
  };

  return fetch(rootUrl + "usuarios.php", reqConfig)
    .then((res) => {
	  return res.json();
    })
    .then((result) => {
	  return result;
    })
    .catch((err) => console.log("error >>", err));
};
